module.exports = __webpack_public_path__ + "static/media/bg5.056eb058.jpg";